import React from 'react';
import axios from 'axios';
import { CustomerConfirmation } from './CustomerConfirmation';
import { StripePaymentForm } from './StripePaymentForm';
import { OrderProgressScreen } from './OrderProgressScreen';
import { rollbar } from '../Rollbar.js'

export class OrderConfirmation extends React.Component {
    constructor(props) {
        super(props);

        var invoiceDateOptions = [];

        for (var i = 1; i <= 28; i++) {
            var lastDigit = i.toString().slice(-1);
            if (lastDigit === "1" && (i < 10 || i > 20)) {
                invoiceDateOptions.push({ value: i, name: i + "st" });
            }
            else if (lastDigit === "2" && (i < 10 || i > 20)) {
                invoiceDateOptions.push({ value: i, name: i + "nd" });
            }
            else if (lastDigit === "3" && (i < 10 || i > 20)) {
                invoiceDateOptions.push({ value: i, name: i + "rd" });
            }
            else {
                invoiceDateOptions.push({ value: i, name: i + "th" });
            }
        }

        this.state = {
            loading: true,
            orderSummary: null,
            error: false,
            redirectFlowId: null,
            timeRemaining: null,
            invoiceDate: 1,
            invoiceDateOptions: invoiceDateOptions,
            complete: false,
            // Stripe inline payment state
            showStripeForm: false,
            stripeClientSecret: null,
            stripePublishableKey: null,
            stripeAmountPence: 0,
            stripeLoading: false,
            stripeError: false,
            completingOrder: false,
            orderApiComplete: false
        };

        this.tick = this.tick.bind(this);
        this.msToMinutesAndSeconds = this.msToMinutesAndSeconds.bind(this);
        this.handleInvoiceDateChange = this.handleInvoiceDateChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleHomeClick = this.handleHomeClick.bind(this);
        this.handleConfirmOrder = this.handleConfirmOrder.bind(this);
        this.handleStripeSuccess = this.handleStripeSuccess.bind(this);
        this.handleStripeCancel = this.handleStripeCancel.bind(this);
        this.completeOrder = this.completeOrder.bind(this);
        this.handleProgressDone = this.handleProgressDone.bind(this);
    }

    handleInvoiceDateChange(e) {
        const newInvoiceDate = parseInt(e.target.value);
        this.setState({ invoiceDate: newInvoiceDate });
    }

    handleSubmit(error) {
        if (error === false) {
            this.setState({ complete: true, completingOrder: false });

            function generateNonce() {
                let array = new Uint32Array(1);
                window.crypto.getRandomValues(array);
                return array[0];
            }

            let nonce = generateNonce();

            var contractValue = Number((this.state.orderSummary.service_cost_inc_vat * this.state.orderSummary.minimum_service_duration_in_months) / 1.2);
            var routerCharge = Number(this.state.orderSummary.router_cost_inc_vat / 1.2);
            var connectionCharge = Number(this.state.orderSummary.connection_cost_inc_vat / 1.2);
            var total = Number(contractValue + routerCharge + connectionCharge);

            if (process.env.NODE_ENV === "production") {
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-754962152/G_FiCOCe4ckZEOid_-cC',
                    'transaction_id': nonce.toString()
                });
                window.gtag('event', 'purchase', {
                    transaction_id: nonce.toString(),
                    value: Number(total),
                    tax: Number(total * 0.2),
                    currency: 'GBP',
                    coupon: this.state.orderSummary.voucher_code,
                    items: [
                    {
                        item_id: '',
                        item_name: this.state.orderSummary.service_description,
                        price: Number(contractValue)
                    },
                    {
                        item_id: '',
                        item_name: this.state.orderSummary.router_description === 'Customer to supply' ? 'Customer to supply router' : this.state.orderSummary.router_description,
                        price: Number(routerCharge)
                    },
                    {
                        item_id: '',
                        item_name: 'Connection charge',
                        price: Number(connectionCharge)
                    }]
                });
            }
            else {
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-754962152/G_FiCOCe4ckZEOid_-cC',
                    'transaction_id': nonce.toString(),
                    'debug_mode': true
                });
                window.gtag('event', 'purchase', {
                    transaction_id: nonce.toString(),
                    value: Number(total),
                    tax: Number(total * 0.2),
                    currency: 'GBP',
                    coupon: this.state.orderSummary.voucher_code,
                    items: [
                    {
                        item_id: '',
                        item_name: this.state.orderSummary.service_description,
                        price: Number(contractValue)
                    },
                    {
                        item_id: '',
                        item_name: this.state.orderSummary.router_description === 'Customer to supply' ? 'Customer to supply router' : this.state.orderSummary.router_description,
                        price: Number(routerCharge)
                    },
                    {
                        item_id: '',
                        item_name: 'Connection charge',
                        price: Number(connectionCharge)
                    }],
                    'debug_mode': true
                });
            }
        }
        else {
            this.setState({ error: true, completingOrder: false });
        }
    }

    handleHomeClick(e) {
        window.location.href = "https://1310.io/";
    }

    async completeOrder(invoiceDate, stripePaymentIntentId = null) {
        let url = process.env.REACT_APP_THIRTEEN_TEN_API + '/confirmation?redirectFlowId=' + this.state.redirectFlowId + '&invoiceDate=' + invoiceDate;
        if (stripePaymentIntentId) url += '&stripePaymentIntentId=' + stripePaymentIntentId;

        await axios.get(url)
        .then(() => {
            if (this.state.completingOrder) {
                // Let the progress animation finish before showing the thank you screen
                this.setState({ orderApiComplete: true });
            } else {
                this.handleSubmit(false);
            }
        })
        .catch(error => {
            rollbar.error(error);
            this.handleSubmit(true);
        });
    }

    // Called by CustomerConfirmation's Confirm Order button
    async handleConfirmOrder(invoiceDate) {
        const summary = this.state.orderSummary;
        const totalCharge = (summary.connection_cost_inc_vat || 0) + (summary.router_cost_inc_vat || 0) + (summary.addons_cost_inc_vat || 0);
        const stripeRequired = !summary.preorder && totalCharge > 0;

        if (stripeRequired) {
            this.setState({ stripeLoading: true, stripeError: false });
            await axios.post(process.env.REACT_APP_THIRTEEN_TEN_API + '/payment/stripe-intent', {
                redirectFlowId: this.state.redirectFlowId,
                invoiceDate
            })
            .then(response => {
                this.setState({
                    stripeClientSecret: response.data.clientSecret,
                    stripePublishableKey: response.data.publishableKey,
                    stripeAmountPence: response.data.amountPence,
                    showStripeForm: true,
                    stripeLoading: false
                });
            })
            .catch(error => {
                rollbar.error(error);
                this.setState({ stripeError: true, stripeLoading: false });
            });
        } else {
            await this.completeOrder(invoiceDate);
        }
    }

    handleStripeSuccess(paymentIntentId) {
        this.setState({ showStripeForm: false, completingOrder: true, orderApiComplete: false });
        this.completeOrder(this.state.invoiceDate, paymentIntentId);
    }

    handleProgressDone() {
        this.setState({ completingOrder: false });
        this.handleSubmit(false);
    }

    handleStripeCancel() {
        this.setState({ showStripeForm: false, stripeClientSecret: null });
    }

    async componentDidMount() {
        if (process.env.NODE_ENV === "production") {
            window.gtag('event', 'gocardless_callback');
        }
        else {
            window.gtag('event', 'gocardless_callback', { 'debug_mode':true });
        }

        const queryString = require('query-string');
        const params = queryString.parse(window.location.search);
        const redirect_flow_id = params.redirect_flow_id;
        const payment_intent = params.payment_intent;
        const invoice_date = parseInt(params.invoice_date) || 1;

        this.setState({ redirectFlowId: redirect_flow_id, invoiceDate: invoice_date });

        await axios.get(process.env.REACT_APP_THIRTEEN_TEN_API + '/confirmation/summary?redirectFlowId=' + redirect_flow_id)
        .then(async response => {
            this.setState({ orderSummary: response.data }, function() {
                this.timerID = setInterval(
                    () => this.tick(),
                    1000
                );
            });

            // Returning from 3DS redirect — verify and auto-complete
            if (payment_intent) {
                const paid = await this.verifyPaymentIntent(payment_intent);
                if (paid) {
                    await this.completeOrder(invoice_date, payment_intent);
                }
            }
        })
        .catch(error => {
            rollbar.error(error);
            this.setState({ error: true });
        })
        .finally(() => {
            this.setState({ loading: false });
        });
    }

    async verifyPaymentIntent(paymentIntentId) {
        try {
            const response = await axios.get(
                process.env.REACT_APP_THIRTEEN_TEN_API + '/payment/stripe-verify?stripeSessionId=' + paymentIntentId
            );
            if (response.data.paid) return true;
            this.setState({ stripeError: true });
            return false;
        } catch (error) {
            rollbar.error(error);
            this.setState({ stripeError: true });
            return false;
        }
    }

    async componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        var expiry = new Date(this.state.orderSummary.expiry_time);
        var now = new Date();
        var remaining = expiry - now;
        if (remaining > 0) {
            this.setState({ timeRemaining: this.msToMinutesAndSeconds(remaining) });
        }
        else {
            window.location.href = '/';
        }
    }

    msToMinutesAndSeconds(ms) {
        var minutes = Math.floor(ms / 60000);
        var seconds = ((ms % 60000) / 1000).toFixed(0);
        if (minutes < 10) {
            return (
                "Time remaining: " + (seconds === 60 ? (minutes+1) + ":00" : minutes + ":" + (seconds < 10 ? "0" : "") + seconds)
            );
        }
        return null;
    }

    render() {
        const showSummary = !this.state.loading
            && !this.state.error
            && !this.state.complete
            && !this.state.stripeLoading
            && !this.state.showStripeForm
            && !this.state.completingOrder
            && this.state.orderSummary;

        return (
            <div className="App m-5">
                <div className="columns is-multiline is-mobile is-centered">
                    <div className="column is-full-mobile is-two-thirds-tablet is-half-desktop is-one-third-widescreen is-one-quarter-fullhd">
                        {
                            (this.state.loading || this.state.stripeLoading) &&
                            <div className="fa-2x">
                                <i className="fas fa-spinner fa-pulse"></i>
                            </div>
                        }
                        {
                            this.state.error &&
                            <div className="block">
                                <p>Sorry, an error occurred while confirming your order details. Please <a target="_blank" rel="noreferrer" href="https://1310.io/contact">send us a message</a> or call us on <a href="tel:03333001310">0333 300 1310</a> to discuss.</p>
                            </div>
                        }
                        {
                            this.state.stripeError &&
                            <div className="block">
                                <p>Sorry, an error occurred while processing your card payment. Please <a target="_blank" rel="noreferrer" href="https://1310.io/contact">send us a message</a> or call us on <a href="tel:03333001310">0333 300 1310</a> to discuss.</p>
                            </div>
                        }
                        {
                            this.state.completingOrder &&
                            <OrderProgressScreen
                                apiComplete={this.state.orderApiComplete}
                                onDone={this.handleProgressDone}
                                hasVoip={(this.state.orderSummary?.voip_addons?.length ?? 0) > 0}
                                hasAdditionalServices={
                                    (this.state.orderSummary?.recurring_addons?.length ?? 0) > 0 ||
                                    (this.state.orderSummary?.addons?.length ?? 0) > 0
                                } />
                        }
                        {
                            this.state.showStripeForm &&
                            <StripePaymentForm
                                clientSecret={this.state.stripeClientSecret}
                                publishableKey={this.state.stripePublishableKey}
                                amountPence={this.state.stripeAmountPence}
                                redirectFlowId={this.state.redirectFlowId}
                                invoiceDate={this.state.invoiceDate}
                                onSuccess={this.handleStripeSuccess}
                                onCancel={this.handleStripeCancel} />
                        }
                        {
                            showSummary &&
                            <div className="block">
                                { this.state.timeRemaining && <h2 className="title is-6"><strong>{this.state.timeRemaining}</strong></h2> }
                                <div className="box">
                                    <p>
                                        Please note: Our payment provider partner, GoCardless, requires the sign-up process to be completed within 25 minutes. After this time, you will be redirected back to the beginning of the process.
                                    </p>
                                </div>
                                <div id="customer-confirmation" className="card selected">
                                    <div className="card-header">
                                        <div className="card-header-title is-centered">
                                            <h2 className="subtitle is-5">Order Summary</h2>
                                        </div>
                                    </div>
                                    <div className="card-content">
                                        <p className="block">
                                            {this.state.orderSummary.name}
                                            <br />{this.state.orderSummary.street_1}, {this.state.orderSummary.city}, {this.state.orderSummary.zip_code}
                                            <br />
                                            {this.state.orderSummary.email}
                                            <br />
                                            {this.state.orderSummary.phone}
                                        </p>
                                        <p className="block">
                                            Selected Product: {this.state.orderSummary.service_description}
                                            <br />
                                            {
                                                this.state.orderSummary.initial_service_cost_inc_vat !== null &&
                                                this.state.orderSummary.initial_service_cost_duration_in_months !== null &&
                                                (
                                                    "£" + (this.state.orderSummary.initial_service_cost_inc_vat.toFixed(2) + " per month for the first "
                                                    + (this.state.orderSummary.initial_service_cost_duration_in_months > 1
                                                        ? this.state.orderSummary.initial_service_cost_duration_in_months + " months, then £"
                                                        : "month, then £")) + this.state.orderSummary.service_cost_inc_vat.toFixed(2) + " per month."
                                                )
                                            }
                                            {
                                                this.state.orderSummary.initial_service_cost_inc_vat !== null &&
                                                this.state.orderSummary.initial_service_cost_duration_in_months == null
                                                && "£" + this.state.orderSummary.initial_service_cost_inc_vat.toFixed(2) + " per month."
                                            }
                                            {
                                                this.state.orderSummary.initial_service_cost_inc_vat == null &&
                                                this.state.orderSummary.initial_service_cost_duration_in_months == null
                                                && "£" + this.state.orderSummary.service_cost_inc_vat.toFixed(2) + " per month."
                                            }
                                            <br />
                                            {this.state.orderSummary.minimum_service_duration_in_months} month minimum contract.
                                        </p>
                                        {
                                            !this.state.showStripeForm &&
                                            <p className="block">
                                                <span className="is-inline-block m-2">Monthly invoice date:</span><br />
                                                <span className="select">
                                                    <select onChange={this.handleInvoiceDateChange}>
                                                    {
                                                        this.state.invoiceDateOptions.map((e) => {
                                                            return <option key={e.value} value={e.value}>{e.name}</option>;
                                                        })
                                                    }
                                                    </select>
                                                </span>
                                                <span className="is-inline-block m-2">of the month.</span>
                                                <br />
                                                <span className="is-inline-block m-2">The first invoice will be raised following your installation. This first invoice will cover the period between your installation and the invoice date, as well as the upcoming month in advance.</span>
                                            </p>
                                        }
                                        <p className="block">
                                            {
                                                <span>
                                                    Connection Charge: £{this.state.orderSummary.connection_cost_inc_vat.toFixed(2)}
                                                    <br /><br />
                                                </span>
                                            }
                                            {
                                                this.state.orderSummary.router_description !== '' &&
                                                    <span>
                                                        Router: {this.state.orderSummary.router_description}
                                                        <br/>
                                                        Router Charge: £{this.state.orderSummary.router_cost_inc_vat.toFixed(2)}
                                                        <br />
                                                    </span>
                                            }
                                            {
                                                this.state.orderSummary.router_address !== '' &&
                                                    <span>
                                                        Router Delivery Address:<br />{this.state.orderSummary.router_address}
                                                        <br />
                                                    </span>
                                            }
                                            {
                                                this.state.orderSummary.addons && this.state.orderSummary.addons.length > 0 &&
                                                    <span>
                                                        <br />
                                                        Extras:
                                                        {this.state.orderSummary.addons.map((addon, i) => (
                                                            <span key={i}><br />{addon.name}: £{addon.price_inc_vat.toFixed(2)}</span>
                                                        ))}
                                                        <br />
                                                    </span>
                                            }
                                            {
                                                this.state.orderSummary.voip_addons && this.state.orderSummary.voip_addons.length > 0 &&
                                                    <span>
                                                        <br />
                                                        Phone services:
                                                        {this.state.orderSummary.voip_addons.map((addon, i) => (
                                                            <span key={i}><br />{addon.name}: £{addon.price_inc_vat.toFixed(2)}/month</span>
                                                        ))}
                                                        <br />
                                                    </span>
                                            }
                                            {
                                                this.state.orderSummary.recurring_addons && this.state.orderSummary.recurring_addons.length > 0 &&
                                                    <span>
                                                        <br />
                                                        Additional services:
                                                        {this.state.orderSummary.recurring_addons.map((addon, i) => (
                                                            <span key={i}><br />{addon.name}: £{addon.price_inc_vat.toFixed(2)}/month</span>
                                                        ))}
                                                        <br />
                                                    </span>
                                            }
                                        </p>
                                        {
                                            (
                                                this.state.orderSummary.connection_cost_inc_vat > 0
                                                || this.state.orderSummary.router_cost_inc_vat > 0
                                            )
                                            && this.state.orderSummary.preorder &&
                                            <p className="block">Connection &amp; router charges (if applicable) will be debited once we have contacted you to book your order in for installation.</p>
                                        }
                                        {
                                            (
                                                this.state.orderSummary.connection_cost_inc_vat > 0
                                                || this.state.orderSummary.router_cost_inc_vat > 0
                                                || (this.state.orderSummary.addons_cost_inc_vat || 0) > 0
                                            )
                                            && !this.state.orderSummary.preorder &&
                                            !this.state.showStripeForm &&
                                            <div className="notification is-info is-light block">
                                                <strong>
                                                    Card payment of £{((this.state.orderSummary.connection_cost_inc_vat || 0) + (this.state.orderSummary.router_cost_inc_vat || 0) + (this.state.orderSummary.addons_cost_inc_vat || 0)).toFixed(2)} required
                                                </strong>
                                                <br />
                                                Your one-off connection, router and extras charges will be taken by card payment when you confirm your order. Your monthly broadband subscription will be collected via Direct Debit.
                                            </div>
                                        }
                                        {
                                            this.state.orderSummary.referral_credit > 0 &&
                                            <p className="block">Referral reward:<br />£{this.state.orderSummary.referral_credit.toFixed(2)} account credit for you and your referrer.</p>
                                        }
                                        {
                                            this.state.orderSummary.current_ISP !== '' &&
                                            <p className="block">Current ISP:<br />{this.state.orderSummary.current_ISP}</p>
                                        }
                                        {
                                            this.state.orderSummary.start_date !== '' &&
                                            <p className="block">Earliest possible start date:<br />{new Date(this.state.orderSummary.start_date).toLocaleDateString()}</p>
                                        }
                                        <h2 className="title is-6">All prices include VAT</h2>
                                    </div>
                                </div>
                                <CustomerConfirmation
                                    redirectFlowId={this.state.redirectFlowId}
                                    invoiceDate={this.state.invoiceDate}
                                    onSubmit={this.handleSubmit}
                                    onConfirm={this.handleConfirmOrder}
                                    orderSummary={this.state.orderSummary} />
                            </div>
                        }
                        {
                            this.state.complete &&
                            <div id="system-confirmation" className="card selected">
                                <div className="card-header">
                                    <div className="card-header-title is-centered">
                                        <h2 className="subtitle is-5">Order Confirmation</h2>
                                    </div>
                                </div>
                                <div className="card-content">
                                    <h1 className="title is-4 mt-3">Thank you for your order</h1>
                                    <p className="m-5">We will be in touch soon to confirm your order details.</p>
                                    <button className="button is-primary mb-3" onClick={this.handleHomeClick}>Home</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}
